export default [
  {
    id: "AR",
    title: "阿根廷",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：8003459139

服务时间: 周一 - 周五：09:00-18:00 ART`,
  },

  {
    id: "EG",
    title: "埃及",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：待定
- **电子邮件**：service.eg@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/eg/)

服务时间: 周日 - 周四：10am-7pm EET`,
  },

  {
    id: "PE",
    title: "秘鲁",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：80009040
- **电子邮件**：service.pe@support.mi.com

服务时间: 周一 - 周五：09:00-18:00 PET`,
  },

  {
    id: "RU",
    title: "俄罗斯",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：8-800-775-66-15
- **电子邮件**：service.ru@xiaomi.com
- **在线客服**：[点击进入](https://ru.chat.kefu.mi.com/page/index/v2?tag=ru&token=cnUjMSNydS53ZWIubWkjN3NiMnFNcVk1VCNnb29kc0RldGFpbA%3D%3D&groupId=P0&locale=ru&closedshow=1&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 周一 - 周五 9:00-20:00 EETDST`,
  },

  {
    id: "FR",
    title: "法国",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：0805 370 916
- **电子邮件**：service.fr@xiaomi.com
- **在线客服**：[点击进入](https://sg.chat.kefu.mi.com/page/index/v2?tag=fr&token=c2cjMTAwOCNmci53ZWIubWkjV0FvMExnak9JMCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=fr&_gl=148npqt_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 周一 - 周五 9:00-20:00，周六 9:00-18:00 FST`,
  },

  {
    id: "PH",
    title: "菲律宾",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **电子邮件**：service.ph@xiaomi.com `,
  },

  {
    id: "CO",
    title: "哥伦比亚",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：18005190083
- **电子邮件**：service.co@support.mi.com

服务时间: 周一 - 周五：09:00-18:00 COT`,
  },

  {
    id: "MY",
    title: "马来西亚",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：1800180112
- **电子邮件**：service.my@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/my/)

服务时间: 周一 - 周五：9am-6pm MYT`,
  },

  {
    id: "US",
    title: "美国",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：1-833-XIAOMI8(1-833-942-6648)
- **电子邮件**：service.us@xiaomi.com
- **在线客服**：[点击进入](https://sg.chat.kefu.mi.com/page/index/v2?tag=cn&token=c2cjMTAwMyNjbi53ZWIubWkuZW4jZGVmYXVsdCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=en&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 每天 8:00 - 18:00 CST`,
  },

  {
    id: "MX",
    title: "墨西哥",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：8002692630
- **电子邮件**：service.mx@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/mx/)

服务时间: 周一 - 周五：09:00 - 18:00 CDT`,
  },

  {
    id: "JP",
    title: "日本",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：0120-300-521
- **电子邮件**：service.jp@support.mi.com

服务时间: 周一 - 周五：09:00 - 18:00 JST`,
  },

  {
    id: "TH",
    title: "泰国",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：1800014171
- **电子邮件**：service.th@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/th/)

服务时间: 周一 - 周五：9am-6pm ICT`,
  },

  {
    id: "ES",
    title: "西班牙",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：902 220 250
- **电子邮件**：service.es@xiaomi.com
- **在线客服**：[点击进入](https://sg.chat.kefu.mi.com/page/index/v2?tag=cn&token=c2cjMTAwNCNjbi53ZWIubWkuZXMjZGVmYXVsdCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=es&_gl=11o3sfgo_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 周一 - 周五 9:00-21:00， 周六 9:00-18:00 CEST`,
  },

  {
    id: "SG",
    title: "新加坡",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：8008528474
- **电子邮件**：service.sg@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/sg/)

服务时间: 周一 - 周五：9am-6pm SGT`,
  },

  {
    id: "IT",
    title: "意大利",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：800 690 921
- **电子邮件**：service.it@xiaomi.com
- **在线客服**：[点击进入](https://sg.chat.kefu.mi.com/page/index/v2?tag=it&token=c2cjMTAwNSNpdC5hcHAubWkjSk96eUV5akNSNiNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=it&_gl=148npqt_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 周一 - 周五 9:00-20:00，周六 9:00-18:00 CEST`,
  },

  {
    id: "IN",
    title: "印度",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：1800-103-6286
- **电子邮件**：service.in@xiaomi.com
- **在线客服**：[点击进入](https://www.mi.com/in/service/online)

服务时间: 每天 8:00 - 23:00 IST`,
  },

  {
    id: "ID",
    title: "印度尼西亚",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：180300650029
- **电子邮件**：service.id@support.mi.com
- **在线客服**：[点击进入](https://www.mi.co.id/id/index.html)

服务时间: 每天 9am-6pm WIB`,
  },

  {
    id: "UK",
    title: "英国",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：0800 916 0561
- **电子邮件**：service.uk@xiaomi.com
- **在线客服**：[点击进入](https://sg.chat.kefu.mi.com/page/index/v2?tag=uk&token=c2cjMTAwMyN1ay53ZWIubWkjWVdCa21oWmhzViNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=en&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

服务时间: 周一 - 周六 9:00 - 18:00 BST`,
  },

  {
    id: "VN",
    title: "越南",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：1800400410
- **电子邮件**：service.vn@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/vn/)

服务时间: 周一 - 周五：9am-6pm ICT`,
  },

  {
    id: "MO",
    title: "中国澳门",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **电子邮件**：service.mo@support.mi.com

服务时间: 周一 - 周日：09:00-18:00 CST`,
  },

  {
    id: "CN",
    title: "中国大陆",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服官网**：https://www.mi.com/service
- **客服热线**：400-100-5678
- **在线客服**：[点击进入](https://support.kefu.mi.com)

服务时间: 每天 8:00 - 18:00 CST`,
  },

  {
    id: "TW",
    title: "中国台湾",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：02-77255376
- **电子邮件**：service.tw@support.mi.com

服务时间: 周一 - 周日：09:00 - 18:00 CST`,
  },

  {
    id: "HK",
    title: "中国香港",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：852-30773620
- **电子邮件**：service.hk@support.mi.com

服务时间: 周一 - 周日：09:00 - 18:00 CST`,
  },

  {
    id: "CL",
    title: "智利",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **客服热线**：800004227
- **电子邮件**：service.cl@support.mi.com
- **在线客服**：[点击进入](https://www.mi.com/cl/)

服务时间: 周一 - 周五：09:00 - 18:00 CLT`,
  },

  {
    id: "GLOBAL",
    title: "国际（其他国家/地区）",
    content: `在此国家/地区的客户服务团队提供如下联系方式：
- **电子邮件**：support.global@support.mi.com `,
  },
];
